import { useNotification } from '@/shared/ui'
import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation } from '@tanstack/vue-query'

/**
 * Функция сохранения группы полей
 */
export const useSendInventObjectGroup = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.id) {
        return http.put(`/manuals/object-types/group/${data.id}`, data)
      } else {
        return http.post(`/manuals/object-types/group`, data)
      }
    },
  })

  const send = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.saved'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}
